exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":root{--iphonex-safe-area-inset-top-portrait:44px;--iphonex-safe-area-inset-right-portrait:0;--iphonex-safe-area-inset-bottom-portrait:34px;--iphonex-safe-area-inset-left-portrait:0;--iphonex-safe-area-inset-top-landscape:0;--iphonex-safe-area-inset-right-landscape:44px;--iphonex-safe-area-inset-bottom-landscape:21px;--iphonex-safe-area-inset-left-landscape:44px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/onsenui/css-components-src/src/iphonex-support/global.css
// module id = 353
// module chunks = 1